import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { type AiBuilderMessage, useAiBuilderChatActions } from '../store';
import { QUIZ_CARD_ACTION_CHOICE_SLOT } from '../store/aiBuilderMessageState';
import { AiBuilderActionChip } from './AiBuilderActionChip';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
import { AiBuilderCheckboxOptionButton } from './AiBuilderCheckboxOptionButton';
import { AiBuilderInlineMarkdown } from './AiBuilderInlineMarkdown';
import { AiBuilderRadioOptionButton } from './AiBuilderRadioOptionButton';
export const AiBuilderChoiceMessage = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'choice';
  }>;
}) => {
  const {
    selectChoiceOption,
    submitChoiceMessage
  } = useAiBuilderChatActions();
  const copy = useAiBuilderChatCopy();

  // 문제 카드 진입 후속 선택지는 고르고 따로 제출하는 select가 아니라
  // assistant action과 같은 즉시 제출 chip으로 동작한다.
  const isImmediateSubmitChoice = message.missingSlot === QUIZ_CARD_ACTION_CHOICE_SLOT;
  const isSingleChoice = message.selectionMode === 'single';
  const selectionModeAriaLabel = isSingleChoice ? copy.choice.singleSelectionAriaLabel : copy.choice.multipleSelectionAriaLabel;
  const selectedOptionIdSet = new Set(message.selectedOptionIds);
  const hasSelectedOption = message.selectedOptionIds.length > 0;
  const copyText = [message.title, message.description].filter(Boolean).join('\n');
  return <div className="flex flex-col gap-sm" data-sentry-component="AiBuilderChoiceMessage" data-sentry-source-file="AiBuilderChoiceMessage.tsx">
      <AiBuilderChatMessageAI data-sentry-element="AiBuilderChatMessageAI" data-sentry-source-file="AiBuilderChoiceMessage.tsx">
        <AiBuilderChatMessageAI.Body className="flex-col gap-2xs break-words" data-sentry-element="unknown" data-sentry-source-file="AiBuilderChoiceMessage.tsx">
          <AiBuilderChoicePrompt message={message} data-sentry-element="AiBuilderChoicePrompt" data-sentry-source-file="AiBuilderChoiceMessage.tsx" />
        </AiBuilderChatMessageAI.Body>
        <AiBuilderChatMessageAI.Copy text={copyText} feedbackMessage={message} data-sentry-element="unknown" data-sentry-source-file="AiBuilderChoiceMessage.tsx" />
      </AiBuilderChatMessageAI>

      {!message.submitted && isImmediateSubmitChoice && <div className="flex min-w-0 max-w-full flex-row flex-wrap justify-end gap-xs pb-md pl-3xl pr-lg">
          {message.options.map(option => <AiBuilderActionChip key={option.id} emoji={option.emoji} label={option.label} title={option.label} onClick={() => {
        // 선택 상태를 store에 먼저 기록해야 submitChoiceMessage가
        // 제출할 라벨을 읽을 수 있다(둘 다 동기 store 갱신).
        selectChoiceOption(message.id, option.id);
        submitChoiceMessage(message.id);
      }} />)}
        </div>}

      {!message.submitted && !isImmediateSubmitChoice && <div className="flex flex-col items-end pb-md pl-3xl pr-lg">
          <div className="flex w-full flex-col items-end gap-xs" role="group" aria-label={`${message.title} ${selectionModeAriaLabel}`} onKeyDownCapture={event => {
        if (event.key !== 'Enter' || event.nativeEvent.isComposing || !hasSelectedOption) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        submitChoiceMessage(message.id);
      }}>
            {message.options.map(option => {
          const optionProps = {
            option,
            selected: selectedOptionIdSet.has(option.id),
            onSelect: () => selectChoiceOption(message.id, option.id)
          };
          return isSingleChoice ? <AiBuilderRadioOptionButton key={option.id} {...optionProps} /> : <AiBuilderCheckboxOptionButton key={option.id} {...optionProps} />;
        })}
          </div>
        </div>}
    </div>;
};
const AiBuilderChoicePrompt = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'choice';
  }>;
}) => {
  return <>
      {message.title.split('\n').map((line, lineIndex) => <p key={`${message.id}-title-${lineIndex}`} className="text-body-lg-medium text-default">
          <AiBuilderInlineMarkdown text={line} />
        </p>)}
      {message.description && <p className="text-body-lg-medium text-default">
          <AiBuilderInlineMarkdown text={message.description} />
        </p>}
    </>;
};